import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { HospitalityContent } from './components/HospitalityContent';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useGetLiftOperatorQuery } from '@/api/v2/liftOperator';

import UnAuthorized from '@/pages/UnAuthorized';

const HospitalityPage: PageWithLayout = () => {
    const { liftOperatorData } = useAuthentication();
    const { data: liftoperator } = useGetLiftOperatorQuery({
        liftOperatorId: liftOperatorData?.liftOperatorId,
    });

    if (!liftoperator) {
        return null;
    }

    if (liftoperator.disableHospitality) {
        return <UnAuthorized />;
    }

    return (
        <>
            <Helmet>
                <title>Hospitality Neu | Starjack Admin</title>
            </Helmet>

            <HospitalityContent newOrEditMode={true} />
        </>
    );
};

HospitalityPage.isProtected = true;
HospitalityPage.permissions = [Permission.HOSPITALITY_NAV];
HospitalityPage.getLayout = (Component) => (
    <SidebarLayout>{Component}</SidebarLayout>
);

export default HospitalityPage;
